import React, { Component } from 'react'
import Header from '../Header'
import './XXXIIs.css'

class XXXIIs extends Component {
  
    render () {
        return (
            <div>
                <Header />
                <div className="bodyXXXIIs">
                    <p className="textXXXII">2020, Tokyo, Japon, 24 juillet - 9 août. A venir</p>
                </div>
            </div>
        )
    }
}

export default XXXIIs